import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import type { PresenceStateUser } from '../editor/editorReducer';
import userPath from '../utils/url/userPath';
import type { PresenceAvatarStatus } from './PresenceAvatar';
import PresenceAvatar from './PresenceAvatar';
import styles from './PresenceAvatarStack.module.scss';

interface PresenceAvatarStackProps {
  users: {
    user: PresenceStateUser;
    status: PresenceAvatarStatus;
  }[];
}

const PresenceAvatarStack = ({ users }: PresenceAvatarStackProps) => (
  <div className={styles.container}>
    {users.map(({ user, status }) => (
      <div key={user.id} className={styles.avatar}>
        <Link key={user.id} to={userPath(user)}>
          <PresenceAvatar status={status} index={user.index} user={user} />
        </Link>
      </div>
    ))}
  </div>
);

export default PresenceAvatarStack;
